module.exports = function(){
	return "innerWidth" in window ? window.innerWidth : document.documentElement.offsetWidth;
};